import { css as _css } from "@emotion/react";
import { Avatar } from '@datacamp/waffles/avatar';
import { tokens } from '@datacamp/waffles/tokens';
import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const UserAvatar = _ref => {
  let {
    userAvatarUrl
  } = _ref;
  return ___EmotionJSX(Avatar, {
    content: ___EmotionJSX("img", {
      alt: "User avatar",
      src: userAvatarUrl
    }),
    contentFill: true,
    css: /*#__PURE__*/_css({
      maxHeight: tokens.sizing.small,
      maxWidth: tokens.sizing.small
    }, "production" === "production" ? "" : ";label:UserAvatar;", "production" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9BdmF0YXIvVXNlckF2YXRhci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBYUkiLCJmaWxlIjoiLi4vLi4vc3JjL0F2YXRhci9Vc2VyQXZhdGFyLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IEF2YXRhciB9IGZyb20gJ0BkYXRhY2FtcC93YWZmbGVzL2F2YXRhcic7XG5pbXBvcnQgeyB0b2tlbnMgfSBmcm9tICdAZGF0YWNhbXAvd2FmZmxlcy90b2tlbnMnO1xuaW1wb3J0IHR5cGUgeyBGQyB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbnR5cGUgVXNlckF2YXRhclByb3BzID0ge1xuICB1c2VyQXZhdGFyVXJsOiBzdHJpbmc7XG59O1xuXG5leHBvcnQgY29uc3QgVXNlckF2YXRhcjogRkM8VXNlckF2YXRhclByb3BzPiA9ICh7IHVzZXJBdmF0YXJVcmwgfSkgPT4gKFxuICA8QXZhdGFyXG4gICAgY29udGVudD17PGltZyBhbHQ9XCJVc2VyIGF2YXRhclwiIHNyYz17dXNlckF2YXRhclVybH0gLz59XG4gICAgY29udGVudEZpbGxcbiAgICBjc3M9e3tcbiAgICAgIG1heEhlaWdodDogdG9rZW5zLnNpemluZy5zbWFsbCxcbiAgICAgIG1heFdpZHRoOiB0b2tlbnMuc2l6aW5nLnNtYWxsLFxuICAgIH19XG4gICAgc2l6ZT1cInNtYWxsXCJcbiAgLz5cbik7XG4iXX0= */"),
    size: "small"
  });
};